import React, { FC, ReactNode } from 'react'

import { SCREEN_QUERY_DEFAULTS } from 'common/query-policy'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

type QueryClientContextProviderProps = {
  children: ReactNode
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: SCREEN_QUERY_DEFAULTS,
  },
})

export const QueryClientContextProvider: FC<QueryClientContextProviderProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
)
